import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.MNwj2I',
    defaultMessage: 'Create new organization',
  },
  createButton: {
    id: 'studio.MNwj2I',
    defaultMessage: 'Create new organization',
  },
  organizationNameDescription: {
    id: 'studio.xzWgp6',
    defaultMessage: 'The display name of the organization',
  },
  cancelLabel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  organizationId: {
    id: 'studio.D0La/m',
    defaultMessage: 'Organization ID',
  },
  organizationIdDescription: {
    id: 'studio.VRUpmK',
    defaultMessage: 'A unique identifier for the organization.',
  },
  organizationName: {
    id: 'studio.NdO+zh',
    defaultMessage: 'Organization name',
  },
  description: {
    id: 'studio.Q8Qw5B',
    defaultMessage: 'Description',
  },
  descriptionDescription: {
    id: 'studio./9RhC2',
    defaultMessage: 'A short description about the organization',
  },
  email: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
  emailDescription: {
    id: 'studio.UHheiE',
    defaultMessage: 'The email address users can use to contact this organization.',
  },
  emailInvalid: {
    id: 'studio.jv0FOj',
    defaultMessage: 'This must be a valid email address',
  },
  website: {
    id: 'studio.JkLHGw',
    defaultMessage: 'Website',
  },
  websiteDescription: {
    id: 'studio.9rXRSk',
    defaultMessage: 'The website of your organization.',
  },
  conflict: {
    id: 'studio.p05LGD',
    defaultMessage: 'An organization with the given ID already exists',
  },
  error: {
    id: 'studio.sa1orx',
    defaultMessage: 'There was a problem creating the organization.',
  },
  logo: {
    id: 'studio.k81S1y',
    defaultMessage: 'Logo',
  },
  logoDescription: {
    id: 'studio.QLD5P4',
    defaultMessage: 'The logo that represents this organization',
  },
  selectFile: {
    id: 'studio.G5EJ8b',
    defaultMessage: 'Select logo',
  },
  descriptionVatIdNumber: {
    defaultMessage: 'Your VAT id number.',
    id: 'studio.+NUiCV',
  },
  vatIdNumber: {
    defaultMessage: 'VAT id number',
    id: 'studio.5Y4+LR',
  },
  descriptionStreetName: {
    id: 'studio.oGJyuC',
    defaultMessage: 'Street name that will be used for invoicing.',
  },
  streetName: {
    id: 'studio.WrhuAL',
    defaultMessage: 'Street name',
  },
  descriptionHouseNumber: {
    id: 'studio.dLb8Qw',
    defaultMessage: 'House number that will be used for invoicing.',
  },
  houseNumber: {
    id: 'studio.GyoFyL',
    defaultMessage: 'House number',
  },
  descriptionCity: {
    id: 'studio.+R3lK1',
    defaultMessage: 'City that will be used for invoicing.',
  },
  city: {
    id: 'studio.TE4fIS',
    defaultMessage: 'City',
  },
  descriptionZipCode: {
    id: 'studio.Vo8m5X',
    defaultMessage: 'Zip code that will be used for invoicing.',
  },
  zipCode: {
    id: 'studio.2gnKy+',
    defaultMessage: 'Zip code',
  },
  selectCountry: {
    id: 'studio.EEdOfh',
    defaultMessage: 'Select a country',
  },
  descriptionCountry: {
    id: 'studio.pOPPD9',
    defaultMessage: 'Country that will be used for invoicing.',
  },
  country: {
    id: 'studio.vONi+O',
    defaultMessage: 'Country',
  },
  descriptionCustomerName: {
    id: 'studio.vfLJpn',
    defaultMessage: 'Customer/company name that will be printed on the invoice.',
  },
  customerName: {
    id: 'studio.61Xs6O',
    defaultMessage: 'Customer name',
  },
  descriptionInvoiceReference: {
    defaultMessage: 'Reference that will be shown on invoices.',
    id: 'studio.IZqJT1',
  },
  invoiceReference: {
    defaultMessage: 'Invoice reference',
    id: 'studio.u8z2PJ',
  },
  payments: {
    defaultMessage: 'Payments',
    id: 'studio.iYc3Ld',
  },
  paymentsHelp: {
    defaultMessage:
      'Settings in this section are related to payments concerning Appsemble subscriptions. Configuring in-app payments for your apps is done on App level, in app settings.',
    id: 'studio.hFIbId',
  },
  preferredLanguage: {
    id: 'studio.R/13HH',
    defaultMessage: 'Preferred language',
  },
  preferredLanguageHelp: {
    id: 'studio.RHDyf2',
    defaultMessage: 'The preferred language to use for organization related emails.',
  },
});
